/**
 * One-time migrator for legacy localStorage data.
 *
 * Before the auth lockdown, the app stored per-user data under keys like:
 *   inp2_data_{userId}_risk_ledger
 *   inp2_data_{userId}_ai_validation
 *   risk_ledger_{userId}
 *
 * After the lockdown, companyId (from the JWT) replaced userId as the
 * namespace key. This migrator copies legacy blobs into the new key
 * namespace and deletes the originals so it only runs once.
 */

const MIGRATED_FLAG = 'inp2_legacy_migrated';

export function migrateLegacyLocalStorage(userId, companyId) {
  if (!userId || !companyId) return false;
  try {
    if (localStorage.getItem(MIGRATED_FLAG)) return false;

    let migrated = 0;
    const suffixes = ['risk_ledger', 'ai_validation'];

    for (const suffix of suffixes) {
      const oldKey = `inp2_data_${userId}_${suffix}`;
      const newKey = `inp2_data_${companyId}_${suffix}`;
      const val = localStorage.getItem(oldKey);
      if (val && !localStorage.getItem(newKey)) {
        localStorage.setItem(newKey, val);
        migrated++;
      }
      if (val) localStorage.removeItem(oldKey);
    }

    const oldRiskKey = `risk_ledger_${userId}`;
    const newRiskKey = `risk_ledger_${companyId}`;
    const riskVal = localStorage.getItem(oldRiskKey);
    if (riskVal && !localStorage.getItem(newRiskKey)) {
      localStorage.setItem(newRiskKey, riskVal);
      migrated++;
    }
    if (riskVal) localStorage.removeItem(oldRiskKey);

    localStorage.setItem(MIGRATED_FLAG, String(Date.now()));
    return migrated > 0;
  } catch {
    return false;
  }
}
